<template>
    <list-page icone="mdi-account-group" titulo="Recurso Pessoal" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:botoes>
          <div>
            <info/>
          </div>
        </template>
        <template v-slot:corpo>

          <div class="cards-totalizadores-container mb-4">
            <v-card v-for="card in cardsTotalizadores" :key="card.chave" class="pa-3 totalizador-card" outlined :style="`background-color: ${card.corFundo}; border-color: ${card.corBorda};`">
              <div class="d-flex">
                <v-avatar size="28" :color="card.corIconeFundo" class="mr-3">
                  <v-icon small :color="card.corIcone">{{ card.icone }}</v-icon>
                </v-avatar>
                <div>
                  <div class="totalizador-titulo">{{ card.titulo }}</div>
                  <div class="totalizador-valor">{{ loadingTotalizadores ? '-' : card.valor }}</div>
                  <div class="totalizador-subtitulo">{{ card.subtitulo }}</div>
                </div>
              </div>
            </v-card>
          </div>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.dataSaida`]="{ item }">
              {{item.dataSaida ? new Date(item.dataSaida).ddmmyyyy() : ''}}
            </template>

          </v-data-table>

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-pessoal v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

        </template>
    </list-page>
</template>
<script>
import { PessoalService } from '@/core/services/projetos';
import { Pessoal } from '@/core/domain/projetos';
import ListPage from "@/components/shared/ListPage";

const totalizadoresPadrao = () => ({
  totalRecursoPessoal: 0,
  totalRecursoPessoalCnpj: 0,
  totalRecursoPessoalCpf: 0,
  totalRecursoPessoalVinculadoProjeto: 0
});

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value: 'actions', sortable: false },
        { text: '#', value: 'id', type:'number' },
        { text: 'Nome', value: 'nome' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Celular', value: 'celular' },
        { text: 'E-mail', value: 'email' },
        { text: 'Data Saida', value: 'dataSaida', type: 'date' },
      ],
      primeiraCarga: true,
      loadingTotalizadores: false,
      totalizadores: totalizadoresPadrao()
    }),
    computed: {
      cardsTotalizadores(){
        return [
          {
            chave: 'total',
            titulo: 'Total de recurso pessoal',
            valor: this.totalizadores.totalRecursoPessoal,
            subtitulo: 'Todos os registros',
            icone: 'mdi-account-group',
            corFundo: '#edf2f7',
            corBorda: '#d4dde8',
            corIconeFundo: '#dfe7f1',
            corIcone: '#3f5d7a'
          },
          {
            chave: 'cnpj',
            titulo: 'Total de recurso pessoal CNPJ',
            valor: this.totalizadores.totalRecursoPessoalCnpj,
            subtitulo: 'Tipo juridica',
            icone: 'mdi-office-building-outline',
            corFundo: '#eaf6ef',
            corBorda: '#d3e8dc',
            corIconeFundo: '#dceddf',
            corIcone: '#2f6f4f'
          },
          {
            chave: 'cpf',
            titulo: 'Total de recurso pessoal CPF',
            valor: this.totalizadores.totalRecursoPessoalCpf,
            subtitulo: 'Tipo fisica',
            icone: 'mdi-account-outline',
            corFundo: '#fff5e9',
            corBorda: '#f0dfc8',
            corIconeFundo: '#f8e9d4',
            corIcone: '#8a5a21'
          },
          {
            chave: 'vinculado',
            titulo: 'Vinculado a projeto aberto',
            valor: this.totalizadores.totalRecursoPessoalVinculadoProjeto,
            subtitulo: 'Contagem unica por pessoal',
            icone: 'mdi-link-variant',
            corFundo: '#f1eef9',
            corBorda: '#ddd6ee',
            corIconeFundo: '#e7e1f4',
            corIcone: '#5d4c8c'
          }
        ];
      }
    },
    created() {
      this.service = new PessoalService();
    },
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    methods: {
      Listar(filter, include){
        this.loading = true;
        this.loadingTotalizadores = true;

        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        this.service.Listar(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, filter, include)
          .then(
            res => {
              this.lista = res.data.items;
              this.totalLista = res.data.count;
            },
            err => {
              this.$swal('Aviso', err.response.data, 'error');
            }
          )
          .finally(() => {
            this.loading = false;
          });

        this.service.Totalizadores(this.search, this.headers, filter)
          .then(
            res => {
              this.totalizadores = res.data;
            },
            err => {
              this.totalizadores = totalizadoresPadrao();
              this.$swal('Aviso', err.response.data, 'error');
            }
          )
          .finally(() => {
            this.loadingTotalizadores = false;
          });
      },
      Novo(){
        this.NovoCadastro(new Pessoal());
      },
      Editar(item){
        this.service.ObterPorId(item.id)
          .then(
            res =>{
              this.EditarCadastro(new Pessoal(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      }
    },
    mounted() {
      this.Listar();
    }
}
</script>
<style scoped>
.totalizador-card {
  border-width: 1px;
  border-style: solid;
  min-height: 108px;
  width: clamp(220px, 18vw, 280px);
}

.cards-totalizadores-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: clamp(10px, 1.2vw, 20px);
}

@media (max-width: 600px) {
  .totalizador-card {
    width: 100%;
  }
}

.totalizador-titulo {
  font-size: 12px;
  color: #5f6a77;
  font-weight: 600;
  line-height: 1.3;
}

.totalizador-valor {
  font-size: 30px;
  font-weight: 700;
  color: #202b37;
  line-height: 1.1;
}

.totalizador-subtitulo {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}
</style>
